<template>
  <div :class="['AppHeader', isMenuOpen ? 'menu-open' : 'menu-closed']">
    <header
      class="flex items-center relative bg-white/75 bg-blur-lg dark:bg-primary-darkest/75 dark:text-white h-gr-double-6 sm:h-gr-double-7 sm:leading-gr-7"
    >
      <div class="container flex justify-between items-center">
        <subdomain-link
          :href="route('home')"
          root
          class="font-logo text-xl sm:text-2xl focus:outline-none focus:ring rounded"
        >
          <span><i class="fak fa-one"></i></span> ONE
        </subdomain-link>
        <nav class="flex text-primary-800 dark:text-white">
          <button
            class="font-bold md:hidden whitespace-nowrap font-bold inline-block"
            @click="toggleMenu()"
          >
            Menu<i class="ml-gr-1 fal fa-xs fa-fw fa-chevron-down duration-300 transform"></i>
          </button>
          <div class="flex items-stretch">
            <div
              :class="[
                'responsive-nav absolute shadow-xl leading-gr-7 top-full inset-x-0 text-center bg-white dark:bg-primary-darkest py-gr-half-7 px-gr-6 md:shadow-none md:bg-transparent md:dark:bg-transparent md:p-0 md:static md:flex space-y-gr-half-5 md:space-y-0',
                isMenuOpen
                  ? 'translate-x-0 opacity-100 pointer-events-auto'
                  : '-translate-y-gr-5 opacity-0 pointer-events-none',
              ]"
            >
              <subdomain-link
                @click="toggleMenu(!isMobile())"
                :class="[
                  'font-bold block',
                  {
                    active: isLinkActive(route('browse')) || isLinkActive(route('browse')),
                  },
                ]"
                :href="route('browse')"
                root
              >
                <span class="lg:hidden">Browse</span> All Titles
              </subdomain-link>
              <subdomain-link
                @click="toggleMenu(!isMobile())"
                :class="[
                  'font-bold block md:hidden lg:inline-block',
                  { active: isLinkActive(route('browse', { sortBy: 'mostRecent' })) },
                ]"
                :href="route('browse', { sortBy: 'mostRecent' })"
                root
              >
                Recent Releases
              </subdomain-link>
              <subdomain-link
                @click="toggleMenu(!isMobile())"
                :class="[
                  'font-bold block md:hidden lg:inline-block',
                  { active: isLinkActive(route('browse', { filterBy: 'free' })) },
                ]"
                :href="route('browse', { filterBy: 'free' })"
                root
              >
                Free Titles
              </subdomain-link>
              <!-- <subdomain-link
                @click="toggleMenu(!isMobile())"
                :class="[
                  'font-bold block',
                  { active: isLinkActive(route('browse', { sortBy: 'popular' })) },
                ]"
                :href="route('browse', { sortBy: 'popular' })"
                >Popular</subdomain-link
              > -->
              <subdomain-link
                @click="toggleMenu(!isMobile())"
                :class="[
                  'font-bold block md:hidden lg:inline-block',
                  {
                    active: isLinkActive(
                      route('browse', { q: 'ONE Audiobooks', searchBy: 'publisher' }),
                    ),
                  },
                ]"
                :href="route('browse', { q: 'ONE Audiobooks', searchBy: 'publisher' })"
                root
              >
                <span class="font-logo">ONE</span> Titles
              </subdomain-link>
              <subdomain-link
                @click="toggleMenu(!isMobile())"
                :class="[
                  'font-bold block relative',
                  {
                    active: isLinkActive(route('page.publishers')),
                  },
                ]"
                :href="route('page.publishers')"
                root
              >
                <small
                  class="absolute left-1/2 whitespace-nowrap leading-none bottom-full -translate-x-1/2 translate-y-1/2 px-gr-3 py-gr-half-3 rounded block bg-white dark:bg-primary-darkest text-xs"
                >
                  <span class="opacity-50"> Author or Publisher? </span>
                </small>
                Promote Your Books
              </subdomain-link>
            </div>

            <cart-nav
              v-if="$page.props.user"
              :items-for-now="$page.props.itemsForNow"
              :items-for-later="$page.props.itemsForLater"
              :promos-on-sale="$page.props.promosOnSale"
              class="-ml-gr-3 lg:ml-0 lg:mr-gr-4"
            />

            <profile-nav v-if="$page.props.user" is-front class="ml-gr-3" />
            <subdomain-link
              v-if="!$page.props.user"
              :href="loginLink"
              root
              class="login-link button button-primary"
            >
              Login
            </subdomain-link>
          </div>
        </nav>
      </div>
    </header>
  </div>
</template>

<script>
  import ProfileNav from '@/Components/ProfileNav';
  import CartNav from '@/Components/CartNav';
  export default {
    name: 'AppHeader',

    components: {
      ProfileNav,
      CartNav,
    },

    data() {
      return {
        isMenuOpen: !this.isMobile(),
      };
    },

    computed: {
      loginLink() {
        let params = {};
        if (route().current() === 'listen.promo.view') {
          let { promo, team } = this.$page.props;
          params = {
            redirect:
              team && promo
                ? route('listen.promo.access', {
                    team,
                    promo,
                  })
                : null,
          };
        }
        return route('login', params);
      },
    },

    mounted() {
      window.addEventListener('resize', this.onResize);
    },

    beforeUnmount() {
      window.removeEventListener('resize', this.onResize, false);
    },

    methods: {
      isLinkActive(route) {
        return route === window.location.href;
      },

      toggleMenu(override = null) {
        this.isMenuOpen = override !== null ? override : !this.isMenuOpen;
      },

      onResize() {
        this.isMenuOpen = !this.isMobile();
      },

      isMobile() {
        return window.innerWidth < 768;
      },
    },
  };
</script>

<style lang="scss" src="./AppHeader.scss" scoped></style>
